import { FormattedMessage } from 'react-intl';
import { MainButton } from '@/shared/ui/Buttons/MainButton.tsx';

export default function ErrorPage() {
  return (
    <section className="p-6">
      <div className="desktop-section flex-col-gap-6 items-center justify-center">
        <h1 className="h2 text-center">
          <FormattedMessage defaultMessage="Ой, что-то пошло не так" />
        </h1>
        <MainButton className="w-full xl:w-auto" to="/">
          <FormattedMessage defaultMessage="На главную" />
        </MainButton>
      </div>
    </section>
  );
}
